import { IAM_URL, IAM_SSO_URL, AI_DOC_URL, EC_URL, EC_ERROR_URL } from "../../utils/Config"
import { CC_PRODUCT_ID, OXE_CLIENT_INFO, SUCCESS, TOKEN_1, TOKEN_2, LANG_LIST } from "../../utils/Constants"
import { deleteRequest, getRequest, postRequest, putRequest } from "../../utils/RequestActions"
import { convertRespArrToSingleObj, getDomains, parseDomainToGUIModal, parseTableData, parseTableSchema } from "../../utils/SchemaParseUtils"
import { getSessionItem, setAssetData } from "../../utils/storageUtils"
import { setContentLoading, setDict, setOxeErrorCodes } from "../reducers/CommonReducer"
import { setGroupAndUsers } from "../reducers/UUMReducer"
import { showOxeErrorsByCodesInDialog } from "./OxeActions"

export const validateChecksum = (payload, callback) => {

    if (window.location.port || getSessionItem(CC_PRODUCT_ID) !== null) { //by-pass checksum validation: duplicate check, localhost 
        callback({ status: "200" })
    } else {
        const request = {
            url: `${IAM_URL}/validateurl`,
            header: { "Content-Type": "application/json" },
            bodyData: JSON.stringify(payload)
        }

        postRequest(request, (res, status) => {
            if (status && res.valid && res.data) {
                setAssetData(res.data)
                callback(res)
            } else {
                callback(status ? res.status : "500")
            }
        })
    }
}

export const isAuthenticated = (callback) => {

    const request = {
        url: `${IAM_SSO_URL}/isauthenticated`,
        options: { credentials: "include" },
        header: {}
    }

    getRequest(request, (res, status) => {
        if (status && res.authStatus) {
            callback(true)
        } else {
            callback(false)
        }
    })
}

export const logout = (callback) => {

    const request = {
        url: `${IAM_SSO_URL}/umc/logout`,
        options: { credentials: "include" },
        header: {}
    }

    getRequest(request, (res, status) => {
        if (status && res.status) {
            console.log("Logout success")
            callback()
        } else {
            console.log("Logout failed")
        }
    })
}

export const getAIHelp = (query, callback) => {
    const request = {
        url: `${AI_DOC_URL}/help?query=${query}`,
        header: { "Authorization": `Bearer ${getSessionItem(TOKEN_1)}` }
    }

    getRequest(request, (res, status) => {
        if (status && res?.AnswerBuilder?.answers?.length) {
            const answers = res.AnswerBuilder.answers[0]

            let documents = []
            answers.documents?.map((doc, index) => {
                let document = {}
                document.id = doc.id
                document.score = Number((doc.score * 100).toFixed(0))
                document.content = doc.content
                document.filename = doc.meta.filename
                document.filetype = doc.meta.filetype
                document.file_path = doc.meta.file_path
                document.page_number = doc.meta.page_number
                document.s3_key = doc.meta.s3_key
                documents.push(document)
            })

            const resp = {
                content: answers.data,
                documents: documents,
                query: answers?.query,
                queryuuid: answers?.meta?.id
            }

            callback(resp)
        } else {
            callback(null)
        }
    })
}

export const getDocURL = (s3_key, page_number, callback) => {
    const request = {
        url: `${AI_DOC_URL}/doc/${s3_key}?page=${page_number}`,
        header: { "Authorization": `Bearer ${getSessionItem(TOKEN_1)}` }
    }

    getRequest(request, (res, status) => {

        if (status && res?.url) {
            callback(res.url)
        } else {
            callback("")
        }
    })
}

export const submitFeedback = (queryuuid, feedback, comment, callback) => {
    const request = {
        url: `${AI_DOC_URL}/feedback/${queryuuid}?feedback=${feedback}&comment=${comment}`,
        header: { "Authorization": `Bearer ${getSessionItem(TOKEN_1)}` }
    }

    getRequest(request, (res, status) => {

        if (status && res?.url) {
            callback(res.url)
        } else {
            callback("")
        }
    })
}


export const fetchAndConcatenateDictionaries = async (language, dispatch) => {

    try {
        // Define the API URLs
        const api1 = `/dict/clientCommon_${language}.json`
        const api2 = `/dict/clientEasyuser_${language}.json`
        const api3 = `/dict/clientSiptrunkconfig_${language}.json`

        // Make API calls in parallel using Promise.all
        const [response1, response2, response3] = await Promise.all([
            fetch(api1),
            fetch(api2),
            fetch(api3)
        ])

        // Convert responses to JSON
        const [data1, data2, data3] = await Promise.all([
            response1.json(),
            response2.json(),
            response3.json()
        ])

        // Concatenate the responses (assuming they are arrays)
        const combinedData = Object.assign({}, data1, data2, data3)

        dispatch(setDict(combinedData))
    } catch (error) {
        dispatch(setDict({}))
    }
}

export const fetchOxeErrorCodesByLang = async (language, oxeClientInfo, dispatch, object = null) => {
    try {
        const lang = LANG_LIST.find(obj => obj.key === language).value;

        let url = EC_ERROR_URL + lang
        const payloadObject = object !== null ? object : null;
        const node = oxeClientInfo.nodeNumber;

        const payload = {
            path: url,
            method: 'GET',
            payload: JSON.stringify(payloadObject),
            ccproductid: getSessionItem(CC_PRODUCT_ID),
            nodenumber: String(node)
        }

        const request = {
            url: EC_URL+'/',
            bodyData: JSON.stringify(payload)
        }

        postRequest(request, (response, status) => {
            if (status && response) {
                dispatch(setOxeErrorCodes(response))
            } else {
                console.log(response)
            }
        })
    } catch (error) {
        dispatch(setOxeErrorCodes({}))
    }
}

/* Get Table schema */
export const getTableSchema = ({ url, action }) => {
    return (dispatch, getState) => {
        const request = {
            url: url
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                const schema = parseTableSchema(response)
                dispatch(action(schema))
            } else {
                console.log(response)
            }
        })
    }
}

/* Get Table data */
export const getTableList = ({ url, action }) => {
    return (dispatch, getState) => {
        const request = {
            url: url
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                const data = parseTableData(response)
                dispatch(action(convertRespArrToSingleObj(data)))
            } else {
                console.log(response)
            }
        })
    }
}

export const getPickupGroupTableList = ({ url, action }) => {
    return (dispatch, getState) => {
        const request = {
            url: url
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                const data = parseTableData(response)
                dispatch(setGroupAndUsers(data))
                dispatch(action(convertRespArrToSingleObj(data)))
            } else {
                console.log(response)
            }
        })
    }
}

export const getHuntingGroupTableList = ({ url, action }) => {
    return (dispatch, getState) => {
        const request = {
            url: url
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                const data = parseTableData(response)
                dispatch(setGroupAndUsers(data))
                dispatch(action(convertRespArrToSingleObj(data)))
            } else {
                console.log(response)
            }
        })
    }
}

/* Actions to get domains of schema */
export const getSchemaDomains = ({ url, action }) => {
    return (dispatch, getState) => {
        const request = {
            url: url
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                const domains = getDomains(response)
                dispatch(action(domains))
                // dispatch(setContentLoading(false))
            } else {
                dispatch(setContentLoading(false))
            }
        })
    }
}

export const getGroupResponse = (operation,{ url, action }, callback) => {
    return (dispatch, getState) => {
        const request = {
            url: url
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                if (response) {
                    const resp = response.response
                    operation === 'update' ? action(resp) : dispatch(action(resp))
                }

            } else {
                dispatch(setContentLoading(false))
                dispatch(showOxeErrorsByCodesInDialog(response, callback))
            }
        })
    }
}
//to get un associated users
export const getUnAssociatedUsers = ({ url, action }) => {
    return (dispatch, getState) => {
        const request = {
            url: url
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                if (response) {
                    const resp = response
                    dispatch(action(resp))
                }
            } else {
                dispatch(setContentLoading(false))
            }
        })
    }
}

export const getExistingGroupResponse = ({ url, action }) => {
    return (dispatch, getState) => {
        const request = {
            url: url
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                if (response) {
                    const createRightObject = response.response[0].domain[0].subdomain.find(obj => obj.id === 'createright')
                    const existingUsers = createRightObject.list[0].enum;//find(obj => obj.id === 'enum');
                    dispatch(action(existingUsers))
                }
            } else {
                dispatch(setContentLoading(false))
            }
        })
    }
}


/* Action to get Schema/data response */
export const getSchemaDataResponse = ({ url, action, callback = null }) => {
    return (dispatch, getState) => {
        const request = {
            url: url
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS && response.response?.length) {
                action && dispatch(action(response.response[0]))
                callback && callback(response.response[0])
            } else {
                console.log(response)
                callback && callback(response);
            }
        })
    }
}

/* Create model item */
export const createModelItem = (url, callback, data = null) => {
    return (dispatch, getState) => {

        const payload = parseDomainToGUIModal(data ?? getState()?.common?.currentMergedData)

        const request = {
            url: url,
            bodyData: JSON.stringify(payload)
        }

        postRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                // dispatch(setContentLoading(false))
                callback && callback(true, response)
            } else {
                console.log(response)
                // dispatch(setContentLoading(false))
                callback && callback(false, response)
            }
        })
    }
}

export const createModelItemForGroup = (url, callback, data) => {
    return (dispatch, getState) => {
        const payload = data !== undefined ? data : null;
        const request = {
            url: url,
            bodyData: JSON.stringify(payload)
        }

        postRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                // dispatch(setContentLoading(false))
                callback && callback(true, response)
            } else {
                console.log(response)
                // dispatch(setContentLoading(false))
                callback && callback(false, response)
            }
        })
    }
}

export const updateModelItemForGroup = (url, callback, data) => {
    return (dispatch, getState) => {
        const payload = data !== undefined ? data : null;
        const request = {
            url: url,
            bodyData: JSON.stringify(payload)
        }

        putRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                // dispatch(setContentLoading(false))
                callback && callback(true, response)
            } else {
                console.log(response)
                // dispatch(setContentLoading(false))
                callback && callback(false, response)
            }
        })
    }
}

/* Update model item */
export const updateModelItem = (url, callback, data = null) => {
    return (dispatch, getState) => {

        const payload = parseDomainToGUIModal(data ?? getState()?.common?.currentMergedData)

        const request = {
            url: url,
            bodyData: JSON.stringify(payload)
        }

        putRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                // dispatch(setContentLoading(false))
                callback && callback(true, response)
            } else {
                console.log(response)
                // dispatch(setContentLoading(false))
                callback && callback(false, response)
            }
        })
    }
}

/* Delete model item */

export const deleteModelItem = (url, callback) => {
    return (dispatch, getState) => {

        const request = {
            url: url
        }

        deleteRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                callback && callback(true, response)
            } else {
                console.log(response)
                callback && callback(false, response)
            }
        })
    }
}


export const getDetailedTableData = (url, callback = null) => {
    return (dispatch, getState) => {
        const request = {
            url: url
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS && response.response?.length) {
                dispatch(setContentLoading(false))
                const data = convertRespArrToSingleObj(parseTableData(response));
                callback && callback(data)
            } else {
                console.log(response)
                dispatch(setContentLoading(false))
                callback && callback(null)
            }
        })
    }
}


export const getExportData = (urlApi, callback = null) => {
    return async (dispatch, getState) => {
        try {
            // Fetch the CSV file from the API
            const response = await fetch(urlApi, {
                method: "GET",
                headers: {
                    "Content-Type": "application/octet-stream",
                    "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`
                },
            });

            if (!response.ok) {
                console.error("Failed to fetch CSV file:", response.statusText)
                return;
            }

            const contentDisposition = response.headers.get("content-disposition")
            const contentType = response.headers.get("content-type")

            let filename = "Operationlogs"
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+?)"/)
                if (filenameMatch && filenameMatch.length > 1) {
                    filename = filenameMatch[1]
                }
            }

            const blob = await response.blob()
            const finalBlob = new Blob([blob], { type: contentType });

            const url = window.URL.createObjectURL(finalBlob)
            const link = document.createElement("a")
            link.href = url
            link.download = filename

            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
            console.error("Error during CSV export:", error)
        }
    };
};

export const getAppVersion = (callback) => {

    const request = {
        url: `${IAM_SSO_URL}/app/version`,
        header: {}
    }
    getRequest(request, (res, status) => {
        if (status && res.app_version) {
            callback(res.app_version)
        } else {
            callback(null)
        }
    })
}
export const getRelaseNotes = (urlApi, callback) => {
    return (dispatch) => {
        fetch(urlApi, {
            method: 'GET',
            headers: {}
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.statusText)
                }
                return response.text().then((urlString) => {
                    callback && callback(true, response)
                    return urlString
                });
            })
            .then((fileUrl) => {
                // Open the returned URL in a new tab
                window.open(fileUrl, '_blank')
                console.error('File opned')
            })
            .catch((error) => {
                console.error('Failed to open file:', error)
                callback && callback(false, error)
            })
    }
}

// export const getRelaseNotes = (urlApi, callback, filename = "Download.pdf") => {
//     return (dispatch) => {
//         fetch(urlApi, {
//             method: 'GET',
//             headers: {}
//         })
//             .then((response) => {
//                 if (!response.ok) {
//                     throw new Error(response.statusText)
//                 }
//                 return response.blob().then((blob) => {
//                     callback && callback(true, response)
//                     return blob;
//                 });
//             })
//             .then((blob) => {
//                 const newTab = window.open('', '_blank')
//                 const fileURL = window.URL.createObjectURL(blob)

//                 // Create an <embed> element
//                 const embed = newTab.document.createElement('embed')
//                 embed.src = fileURL
//                 embed.type = 'application/pdf'
//                 embed.style.width = '100%'
//                 embed.style.height = '100%'
//                 embed.style.border = 'none'

//                 // Clear any default content and append embed
//                 newTab.document.body.innerHTML = ''
//                 newTab.document.body.style.margin = '0'
//                 newTab.document.body.appendChild(embed)


//                  console.log("downloaded file new")
                
//                 // window.open(downloadUrl, '_blank')
//                 // const link = document.createElement('a')
//                 // link.href = downloadUrl

//                 // link.download = filename
//                 // document.body.appendChild(link)
//                 // link.click()
//                 // link.remove()

//                 setTimeout(() => URL.revokeObjectURL(fileURL), 3000);
//             })
//             .catch((error) => {
//                 console.error('Failed to download file:', error)
//                 callback && callback(false, error)
//             })
//     }
// }

//  utils/downloadFile.js
export const downloadUMCZipFile = async ({ directory, entraID, password, url }) => {
    const payload = { directory, entraID, password }

    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok) throw new Error("Download failed")

    const blob = await response.blob()
    const urlBlob = window.URL.createObjectURL(blob)

    const link = document.createElement("a")
    link.href = urlBlob;
    link.setAttribute("download", "Encrypted_SCIM_Access_Data.zip")
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(urlBlob)
}

export const getTimeLineData = (urlApi, callback = () => { }) => {
    return async (dispatch, getState) => {
        try {
            const res = await fetch(urlApi, {
                method: "GET",
                headers: {
                }
            })

            if (!res.ok) {
                console.warn("Fetch failed with status:", res.status)
                callback(null)
                return
            }

            const data = await res.json();
            callback(data)
        } catch (error) {
            console.error("Error:", error)
            callback(null)
        }
    }
}